
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/assets",
      function () {
        return require("private-next-pages/docs/errors/assets.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/assets"])
      });
    }
  